"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INSIGHTS_TITLE_COPY = exports.INSIGHTS_FIRST_VIEW_TITLE_COPY = void 0;
/**
 * CALL-06 decision 5 (Paul, 2026-10-27; report 164): "All set!" on Insights' first view only.
 * Both apps said it on every visit, inline. The first view, per account on that device, gets
 * the welcome line; every later view the plain title.
 */
exports.INSIGHTS_FIRST_VIEW_TITLE_COPY = "All set! Here's your snapshot";
/** Insights' title after the first view. */
exports.INSIGHTS_TITLE_COPY = "Your snapshot";
//# sourceMappingURL=insightsTitleCopy.js.map